<div class="fx-layout-row fx-content-center" id="{{ chartID }}"></div>
